/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Create a new SecurityOwnership.
 */
export const securityOwnershipCreateParams = zod.object({
  "fundFamilyId": zod.string()
})

export const securityOwnershipCreateBody = zod.object({
  "commitment_amount": zod.string().min(1),"owning_entity_id": zod.string().min(1),"security_class_id": zod.string().min(1),"fund_family_id": zod.string().min(1),"investor_class_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"closing_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"state": zod.enum(['draft', 'active', 'exited', ""]).optional(),"borrowing_base_group_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Get a specific Commitment.
 */
export const securityOwnershipRetrieveParams = zod.object({
  "fundFamilyId": zod.string(),"id": zod.string()
})

export const securityOwnershipRetrieveResponseAnnotationsSetMin = 2;
export const securityOwnershipRetrieveResponseAnnotationsSetMax = 2;

export const securityOwnershipRetrieveResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(securityOwnershipRetrieveResponseAnnotationsSetMin).max(securityOwnershipRetrieveResponseAnnotationsSetMax)).optional(),"commitment_amount": zod.string().min(1),"owning_entity_id": zod.string().min(1),"security_class_id": zod.string().min(1),"fund_family_id": zod.string().min(1),"investor_class_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"closing_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"state": zod.enum(['draft', 'active', 'exited', ""]).optional(),"borrowing_base_group_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1),"owned_entity_id": zod.string().min(1),"exit_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"exit_reason": zod.enum(['not_exited', 'secondary', 'transfer', 'dissolved', ""]).optional(),"side_letter_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Update a specific Security Ownership.
 */
export const securityOwnershipUpdateParams = zod.object({
  "fundFamilyId": zod.string(),"id": zod.string()
})

export const securityOwnershipUpdateQueryParams = zod.object({
  "version_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).optional()
})

export const securityOwnershipUpdateBody = zod.object({
  "commitment_amount": zod.string().min(1),"owning_entity_id": zod.string().min(1),"security_class_id": zod.string().min(1),"fund_family_id": zod.string().min(1),"investor_class_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"closing_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"state": zod.enum(['draft', 'active', 'exited', ""]).optional(),"borrowing_base_group_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"exit_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"exit_reason": zod.enum(['not_exited', 'secondary', 'transfer', 'dissolved', ""]).optional(),"side_letter_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

export const securityOwnershipUpdateResponseAnnotationsSetMin = 2;
export const securityOwnershipUpdateResponseAnnotationsSetMax = 2;

export const securityOwnershipUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(securityOwnershipUpdateResponseAnnotationsSetMin).max(securityOwnershipUpdateResponseAnnotationsSetMax)).optional(),"commitment_amount": zod.string().min(1),"owning_entity_id": zod.string().min(1),"security_class_id": zod.string().min(1),"fund_family_id": zod.string().min(1),"investor_class_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"closing_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"state": zod.enum(['draft', 'active', 'exited', ""]).optional(),"borrowing_base_group_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1),"owned_entity_id": zod.string().min(1),"exit_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"exit_reason": zod.enum(['not_exited', 'secondary', 'transfer', 'dissolved', ""]).optional(),"side_letter_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Deletes a security ownership from a closing
 */
export const securityOwnershipDeleteParams = zod.object({
  "fundFamilyId": zod.string(),"id": zod.string()
})

/**
 * Gets the cancel correct data for a security ownership
 */
export const securityOwnershipCancelCorrectListParams = zod.object({
  "fundFamilyId": zod.string(),"securityOwnershipId": zod.string()
})

export const securityOwnershipCancelCorrectListQueryParams = zod.object({
  "fund_family_event_id": zod.string().optional()
})

/**
 * Cancel Correct a security ownership.
 */
export const securityOwnershipCancelCorrectParams = zod.object({
  "fundFamilyId": zod.string(),"securityOwnershipId": zod.string()
})

export const securityOwnershipCancelCorrectQueryParams = zod.object({
  "fund_family_event_id": zod.string().optional()
})

export const securityOwnershipCancelCorrectBody = zod.object({
  "cancel_correct_investor_class_id": zod.string().min(1),"effective_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Finalize security ownership cancel correct.
 */
export const securityOwnershipCancelCorrectFinalizeParams = zod.object({
  "fundFamilyId": zod.string(),"securityOwnershipId": zod.string()
})

export const securityOwnershipCancelCorrectFinalizeQueryParams = zod.object({
  "fund_family_event_id": zod.string().optional()
})

